import { gql } from 'graphql-request'

export const GET_POPULAR_BOOK_SEARCH_LOGS = gql`
  query PopularBookSearchLogs(
    $dateRange: DatePicker
    $limitPerPage: Int
    $page: Int
    $orderBy: PopularBookSearchLogsOrderBy
    $searchBy: SearchBy!
    $searchText: String
  ) {
    popularBookSearchLogs(
      dateRange: $dateRange
      limitPerPage: $limitPerPage
      page: $page
      orderBy: $orderBy
      searchBy: $searchBy
      searchText: $searchText
    ) {
      data {
        totalPopularSearch
        searchText
      }
      page
    }
  }
`
